import getFetchOptions from './utils/getFetchOptions.js';
import fetchJSON from './utils/fetchJSON.js';
const options = {
  circuitBreaker: {
    id: 'cbh',
    timeout: 1000,
    resetTimeout: 300000,
    fallback: {
      error: 'Circuit Breaker for cbh/history/ is open.'
    }
  }
};
function tradeInFetcher(path) {
  return {
    path: path + 'cars-for-sale/cbh/history/',
    async fetch(pixAllId, debug) {
      try {
        const endpoint = this.path + pixAllId;
        const queryString = '?pagetypefilter=own' + (debug ? '&debug=true' : '');
        const data = await fetchJSON(endpoint + queryString, getFetchOptions(options));
        return data;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching tradeIn data: ', error);
      }
      return {};
    }
  };
}
export { tradeInFetcher as default };
